module.exports = "/images/ny-blck-3.jpg";